import { Link } from "@tanstack/react-router"
import { ChevronLeft } from "lucide-react"

/** Phone layout large title, with an optional trailing action. */
export const MobileTitleRow = ({
  title,
  action,
}: {
  title: string
  action?: React.ReactNode
}) => (
  <div className="mb-4 flex min-h-11 items-center justify-between gap-3 desktop:hidden">
    <h1 className="text-[34px] leading-tight font-semibold">{title}</h1>
    {action}
  </div>
)

/** Phone layout top bar: `‹ label` back link and an optional trailing
 *  control. Sticks to the top, below the safe area. */
export const MobileBackBar = ({
  to,
  label,
  trailing,
}: {
  to: string
  label: string
  trailing?: React.ReactNode
}) => (
  <div className="sticky top-0 z-40 border-b-[0.5px] border-(--surface-hairline) bg-background/90 pt-[env(safe-area-inset-top)] backdrop-blur-md desktop:hidden">
    <div className="mx-auto flex h-11 max-w-(--shell-max-width) items-center justify-between px-2">
      <Link
        to={to}
        className="flex h-11 items-center gap-0.5 pr-2 text-[17px] text-primary"
      >
        <ChevronLeft className="size-6" aria-hidden />
        {label}
      </Link>
      {trailing}
    </div>
  </div>
)
